export async function fetchWithAuth(url, options = {}) {
  {/*
  const access = localStorage.getItem('access');
  const refresh = localStorage.getItem('refresh');

  options.headers = {
    ...options.headers,
    'Authorization': `Bearer ${access}`,
  };

  let res = await fetch(url, options);

  if (res.status === 401 && refresh) {
    const refreshRes = await fetch('/api/token/refresh/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh })
    });

    if (refreshRes.ok) {
      const data = await refreshRes.json();
      localStorage.setItem('access', data.access);
      options.headers['Authorization'] = `Bearer ${data.access}`;
      res = await fetch(url, options); // retry original request
    } else {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      window.location.href = '/login';
    }
  }

  return res;
  */}
  return fetch(url, options);
}
